import React from 'react';
import { UpArrow } from '../icons/Icons';

const PageOne = (props) => {
  return (
    <div className="kids-quiz__page">
      <h1>Let's get started...</h1>
      <p className="helper-text">In just a few moments, we’ll recommend a unique combination of 11 high-quality nourishments to suit your child’s mind and body.</p>

      <div className="kids-quiz__question">
        <label>What is your child's name?</label>
        <p className="helper-text">For that extra special finishing touch, we'll print your child's name on each individual vitamin wrapper.</p>
        <input type="text" onChange={e => props.updateKidsName(e.target.value.replace(/(?:^|-)\S/g, a => a.toUpperCase()))} value={props.kidsName}></input>
      </div>

      <a href="#gender" className={`question-divider ${props.kidsName ? 'question-divider--show' : ''}`}>
        <UpArrow />
      </a>

      <div id="gender" className={`kids-quiz__question ${props.kidsName ? 'kids-quiz__question--show--delayed' : 'kids-quiz__question--hidden'}`}>
        <p className="question__title">{props.kidsName} is...</p>
        <div className="answers-row--3">
          {props.renderGenderAnswers}
        </div>
      </div>

      <a href="#age" className={`question-divider ${props.kidsName && props.gender ? 'question-divider--show' : ''}`}>
        <UpArrow />
      </a>

      <div id="age" className={`kids-quiz__question ${props.kidsName && props.gender ? 'kids-quiz__question--show' : 'kids-quiz__question--hidden'}`}>
        <label className="question__title">How old {props.gender === 'male' ? 'is he' : props.gender === 'female' ? 'is she' : 'are they'}?</label>
        <input onChange={props.onChangeNumber} onBlur={props.checkAge} value={props.age} pattern="\d*"></input>
      </div>

      {props.ageWarningMessage()}

      <div className={`next-page ${props.suitableAge && props.age ? 'next-page--show' : 'next-page--hidden'}`} onClick={() => props.nextPage('1')}>Continue</div>
    </div>
  );
}

export default PageOne;